<app-dialog-header
  title="{{ ('scheduler.general.add-selected' | translate) + ' ' + ('scheduler.visit-type.skillProfiles.title' | translate) }}"
  (closeClicked)="onCancelClick()">
</app-dialog-header>

<mat-dialog-content>
  <mat-selection-list #skillProfileSelect>
    @for (skillProfile of availableList; track skillProfile) {
    <mat-list-option [value]="skillProfile">
      {{ skillProfile.description }}
    </mat-list-option>
    }
  </mat-selection-list>
  @if ((visitTypeResourceStore.entities | async).length===0) {
  <div>
    <div class="container">
      <div class="row">
        {{ 'scheduler.resource-detail.no-options' | translate }}
      </div>
      <div class="row">
      </div>
    </div>
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="onSelectClick()" [disabled]="skillProfileSelect.selectedOptions.selected.length===0" color="primary"
    mat-raised-button>{{ 'scheduler.general.select' | translate }}
  </button>
</mat-dialog-actions>